import React from "react";
import VeritasHeader from "veritas/shared/VeritasHeader";
import { Grid } from "semantic-ui-react";
import ServiceDetailPage from "../shared/ServiceDetailPage";
import { connect } from "react-redux";
import {
    loadResourcesForDPServiceForm,
    updatedDPServiceRefresh
} from "../../../add-edit/actions/AddEditDPServiceActions";
import { fetchServiceDetails, unmountServiceDetail } from "../../actions/ServiceDetailActions";
import { fetchAllServices} from "../../actions/ServicesActions";
import {fetchAllOrganizations} from "../../../data-providers/actions/DataProviderActions";
import {fetchAllCountries} from "../../../country-coverage/actions/CountriesActions";
import Sidebar from "../../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../../shared/VeritasSidebarButtons";

export class KYCServiceDetailPage extends React.Component {

    componentDidMount() {
        const {serviceID} = this.props.params;
        this.props.getServiceDetail(serviceID);
        window.scrollTo(0, 0);

        // If the application reloads at this point, make an API call
        // to get all the services so that for a possible navigation
        // directly to the KYC or KYB Services List page, the data is
        // loaded for rendering.
        if (this.props.all_services.length === 0) {
            this.props.getAllServices();
        }
        if (this.props.all_organizations.length === 0) {
            this.props.getAllOrganizations();
        }
        if (this.props.all_countries.length === 0) {
            this.props.getAllCountries();
        }
        if (this.props.all_billing_groups.length === 0 || this.props.all_service_sets.length === 0 || this.props.all_service_config_names.length === 0) {
            this.props.getSupportingSelections();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { serviceID } = this.props.params;
        if (this.props.updatedDPService) {
            this.props.getServiceDetail(serviceID);
            this.props.updatedDPServiceRefresh();
        }
        // On creation of a new service from a service detail page, Marvel was not reloading or
        // fetching the data of the newly created service keeping it on the same old service Detail Page.
        if (prevProps.params !== this.props.params) {
            this.props.getServiceDetail(serviceID);
        }
        let docTitle = `Veritas - `
        // eslint-disable-next-line no-lone-blocks
        {Object.keys(this.props.serviceDetail).length === 0
            ? document.title = docTitle
            : document.title = docTitle + this.props.serviceDetail.service_detail.service_name}
    }

    componentWillUnmount() {
        this.props.unmountServiceDetail();
    }

    render() {
        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        {Object.keys(this.props.serviceDetail).length === 0
                            ? null
                            : (
                                // fix breadcrumb with new country data structure
                                // <Breadcrumb />
                                <ServiceDetailPage
                                    resourceType="kyc"
                                    serviceDetail={this.props.serviceDetail}
                                    dpInputFields={this.props.dpInputFields}
                                    requiredInputs={this.props.requiredInputs}
                                    dpSources={this.props.dpSources}
                                />
                            )}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isDPEditor,
    all_services: state.veritas.services.all_services,
    all_countries: state.veritas.countries.all_countries,
    all_providers: state.veritas.providers.all_providers,
    all_organizations: state.veritas.providers.all_organizations,
    all_billing_groups: state.veritas.billingGroups.all_billing_groups,
    all_service_sets: state.veritas.services.all_service_sets,
    all_service_config_names: state.veritas.services.all_service_config_names,
    serviceDetail: state.veritas.serviceDetail.service,
    dpInputFields: state.veritas.serviceDetail.dpInputFields,
    requiredInputs: state.veritas.serviceDetail.requiredInputs,
    dpSources: state.veritas.serviceDetail.dpSources,
    updatedDPService: state.veritas.addEdit.addEditDPService.updatedDPService,
});

const mapDispatchToProps = dispatch => ({
    getServiceDetail: (serviceID) => { dispatch(fetchServiceDetails(serviceID)) },
    getAllServices: () => { dispatch(fetchAllServices()) },
    getAllCountries: () => {dispatch(fetchAllCountries())},
    getAllOrganizations: () => { dispatch(fetchAllOrganizations()) },
    unmountServiceDetail: () => { dispatch(unmountServiceDetail()) },
    updatedDPServiceRefresh: () => { dispatch(updatedDPServiceRefresh()) },
    getSupportingSelections: () => {dispatch(loadResourcesForDPServiceForm())},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYCServiceDetailPage)
